<div class="modal-box add-company-modal" cdkDrag>
    <form class="add-company-modal__form modal-form" [formGroup]="addCompanyForm" (ngSubmit)="onSubmit()">
        <div class="modal-header add-company-modal__header" cdkDragHandle>
            <div class="add-company-modal__headline modal-headline">
                <span class="add-company-modal__eyebrow modal-eyebrow">{{ 'COMPANY' | translate }}</span>
                <h4 class="modal-title add-company-modal__title modal-heading">{{ id === null ? ('ADD_COMPANY' | translate) : ('EDIT_COMPANY' | translate) }}</h4>
            </div>
            <button type="button" class="add-company-modal__close modal-close" [attr.aria-label]="('CLOSE' | translate)" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body add-company-modal__body">
            <div class="add-company-modal__sections modal-sections">
                <section class="add-company-modal__panel modal-panel">
                    <div class="add-company-modal__grid modal-grid">
                        <div class="add-company-modal__field add-company-modal__field--span-2 modal-field">
                            <label class="add-company-modal__label modal-label" for="name">{{ 'NAME' | translate }}</label>
                            <input id="name" type="text" class="form-control add-company-modal__control modal-control" formControlName="name"
                                [ngClass]="{ 'is-invalid': submitted && f.name.errors }" [placeholder]="('ENTER_COMPANY_NAME' | translate)">
                            <div *ngIf="submitted && f.name.errors" class="add-company-modal__feedback modal-feedback">
                                <div *ngIf="f.name.errors.required">{{ 'NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="add-company-modal__pair-row">
                            <div class="add-company-modal__field modal-field">
                                <label class="add-company-modal__label modal-label" for="companyOwnerId">{{ 'COMPANY_OWNER' | translate }}</label>
                                <ng-select id="companyOwnerId" class="add-company-modal__select modal-select"
                                    [ngClass]="{ 'is-invalid': submitted && f.companyOwnerId.errors }"
                                    [placeholder]="('SELECT_PLACEHOLDER' | translate)"
                                    [items]="allCompanyOwners" bindLabel="displayName" bindValue="id" formControlName="companyOwnerId">
                                </ng-select>
                                <div *ngIf="submitted && f.companyOwnerId.errors" class="add-company-modal__feedback modal-feedback">
                                    <div *ngIf="f.companyOwnerId.errors.required">{{ 'COMPANY_OWNER_REQUIRED' | translate }}</div>
                                </div>
                            </div>

                            <div class="add-company-modal__field modal-field">
                                <label class="add-company-modal__label modal-label" for="marketingManagers">{{ 'MARKETING_MANAGERS' | translate }}</label>
                                <ng-select id="marketingManagers" class="add-company-modal__select modal-select"
                                    [placeholder]="('SELECT_PLACEHOLDER' | translate)" [multiple]="true"
                                    [items]="allMarketingManagers" bindLabel="displayName" bindValue="id"
                                    formControlName="marketingManagers">
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="add-company-modal__panel modal-panel">
                    <div class="add-company-modal__panel-header modal-panel-header">
                        <span class="add-company-modal__panel-eyebrow modal-panel-eyebrow">{{ 'PRIMARY_CONTACT' | translate }}</span>
                        <p class="add-company-modal__panel-subtitle modal-panel-subtitle"><em>{{ 'PRIMARY_CONTACT_SECTION_NOTE' | translate }}</em></p>
                    </div>

                    <div class="add-company-modal__grid modal-grid">
                        <div class="add-company-modal__pair-row">
                            <ng-container *ngIf="instance.isLastNameFirst; else contactFirstLastOrder">
                                <div class="add-company-modal__field modal-field">
                                    <label class="add-company-modal__label modal-label" for="contactLastName">{{ 'LAST_NAME' | translate }}</label>
                                    <input id="contactLastName" type="text" class="form-control add-company-modal__control modal-control" formControlName="contactLastName"
                                        [ngClass]="{ 'is-invalid': submitted && f.contactLastName.errors }"
                                           [readonly]="true">
                                </div>

                                <div class="add-company-modal__field modal-field">
                                    <label class="add-company-modal__label modal-label" for="contactFirstName">{{ 'FIRST_NAME' | translate }}</label>
                                    <input id="contactFirstName" type="text" class="form-control add-company-modal__control modal-control" formControlName="contactFirstName"
                                        [ngClass]="{ 'is-invalid': submitted && f.contactFirstName.errors }"
                                           [readonly]="true">
                                </div>
                            </ng-container>
                        </div>

                        <ng-template #contactFirstLastOrder>
                            <div class="add-company-modal__field modal-field">
                                <label class="add-company-modal__label modal-label" for="contactFirstName">{{ 'FIRST_NAME' | translate }}</label>
                                <input id="contactFirstName" type="text" class="form-control add-company-modal__control modal-control" formControlName="contactFirstName"
                                    [ngClass]="{ 'is-invalid': submitted && f.contactFirstName.errors }"
                                       [readonly]="true">
                            </div>

                            <div class="add-company-modal__field modal-field">
                                <label class="add-company-modal__label modal-label" for="contactLastName">{{ 'LAST_NAME' | translate }}</label>
                                <input id="contactLastName" type="text" class="form-control add-company-modal__control modal-control" formControlName="contactLastName"
                                    [ngClass]="{ 'is-invalid': submitted && f.contactLastName.errors }"
                                       [readonly]="true">
                            </div>
                        </ng-template>

                        <div class="add-company-modal__pair-row">
                            <div class="add-company-modal__field modal-field">
                                <label class="add-company-modal__label modal-label" for="contactEmail">{{ 'EMAIL' | translate }}</label>
                                <input id="contactEmail" type="text" class="form-control add-company-modal__control modal-control" formControlName="contactEmail"
                                    [ngClass]="{ 'is-invalid': submitted && f.contactEmail.errors }" [readonly]="true">
                            </div>

                            <div class="add-company-modal__field modal-field">
                                <label class="add-company-modal__label modal-label" for="contactPhone">{{ 'PHONE' | translate }}</label>
                                <input id="contactPhone" type="text" class="form-control add-company-modal__control modal-control" formControlName="contactPhone"
                                    [ngClass]="{ 'is-invalid': submitted && f.contactPhone.errors }" [readonly]="true">
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer add-company-modal__footer" cdkDragHandle>
            <div class="add-company-modal__actions modal-actions">
                <button type="button" class="red-outline-button add-company-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button *ngIf="isAdmin || canWrite || canCreate" type="submit" class="blue-button add-company-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
